class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

    // Holder for the Flickity instance
    this.upsellFlickity = null;
    this._upsellInitTimeout = null;

    // MutationObserver: watch for upsell list being inserted/replaced
    this._upsellObserver = new MutationObserver((mutationsList) => {
      // quick heuristic: if nodes were added/removed, schedule init
      let changed = false;
      for (const m of mutationsList) {
        if ((m.addedNodes && m.addedNodes.length) || (m.removedNodes && m.removedNodes.length)) {
          changed = true;
          break;
        }
      }
      if (changed) {
        if (this._upsellInitTimeout) clearTimeout(this._upsellInitTimeout);
        // small debounce to allow DOM replace to settle
        this._upsellInitTimeout = setTimeout(() => this.initUpsellFlickity(), 0.1);
      }
    });

    // Observe subtree of the drawer (the sections are injected inside)
    this._upsellObserver.observe(this, { childList: true, subtree: true });
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  /**
   * Initialize (or re-init) the Flickity upsell slider.
   * This is safe to call repeatedly.
   */
  initUpsellFlickity() {
    const upsellList = this.querySelector('cart-drawer-upsell .products_list');

    // If list not present, destroy previous instance if any and bail out
    if (!upsellList || typeof Flickity === 'undefined') {
      if (this.upsellFlickity) {
        try { this.upsellFlickity.destroy(); } catch (e) { /* ignore */ }
        this.upsellFlickity = null;
      }
      return;
    }

    // If already initialized on the same element, just resize (helps when layout changes)
    if (this.upsellFlickity && this.upsellFlickity.element === upsellList) {
      try {
        // ensure layout is correct on next paint
        requestAnimationFrame(() => {
          this.upsellFlickity.resize();
        });
      } catch (e) { /* ignore */ }
      return;
    }

    // Destroy any previous instance (from a previous DOM node)
    if (this.upsellFlickity) {
      try { this.upsellFlickity.destroy(); } catch (e) { /* ignore */ }
      this.upsellFlickity = null;
    }

    // Initialize a fresh Flickity instance on the current upsellList
    requestAnimationFrame(() => {
      try {
        this.upsellFlickity = new Flickity(upsellList, {
          imagesLoaded: true,
          rightToLeft: true,
          cellAlign: 'right',
          pageDots: false,
          wrapAround: false,
          contain: true
        });

        // a tiny delay to be safe: resize after images/layout settle
        setTimeout(() => {
          try { this.upsellFlickity.resize(); } catch (e) { /* ignore */ }
        }, 80);
      } catch (err) {
        console.error('Flickity init failed on upsellList:', err);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => { this.classList.add('animate', 'active') });

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    if(document.querySelector("#Details-menu-drawer-container") && document.querySelector("#Details-menu-drawer-container").hasAttribute("open")){
      document.querySelector("#Details-menu-drawer-container").removeAttribute("open");
      document.querySelector("#Details-menu-drawer-container").classList.remove("menu-opening");
      document.querySelector(".header__icon--menu").setAttribute("aria-expanded",false);
      document.body.classList.remove("overflow-hidden-tablet");
      document.querySelector(".section-header").classList.remove("menu-open");
    }
    if(document.querySelector(".header__search details") && document.querySelector(".header__search details").hasAttribute("open")){
      document.querySelector(".header__search details").removeAttribute("open");
      document.querySelector(".section-header").classList.remove("menu-open");
    }
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState, discount, discountcode) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;

    // ✅ SHOW POPUP WHEN PRODUCT ADDED
    if (!discount) {
      setTimeout(() => {
        showAddPopup();
      }, 200);
    }

    this.getSectionsToRender().forEach((section => {
      // keep your discount handling logic exactly as you had it
      if(discount){
        const parser = new DOMParser();
        let CARThtml = parser.parseFromString(parsedState.sections[section.id], "text/html");
        var discount_applied = false;
        if(CARThtml.querySelector("ul.discounts.list-unstyled")){
          CARThtml.querySelectorAll("ul.discounts.list-unstyled").forEach((ele) => {
            if(ele.innerHTML){
              discount_applied = true;
              return false;
            }
          })
          if(discount_applied){
            console.log("discount applied",discount_applied)
            setTimeout(function(){
              const errEl = document.querySelector("cart-coupon-form .error");
              if (errEl) errEl.classList.add("d-none");
            }, 500);
          }else{
            setTimeout(function(){
              let pre_Val = discountcode;
              const promoWrap = document.querySelector(".promo-code-wrap");
              const errEl = document.querySelector("cart-coupon-form .error");
              const inputEl = document.querySelector("cart-coupon-form input[type='text']");
              if (promoWrap) promoWrap.classList.add("open");
              if (errEl) errEl.classList.remove("d-none");
              if (inputEl) inputEl.value = pre_Val;
            }, 500);
          }
        }
      }

      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if (sectionElement) {
        sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    // After sections are injected, ensure overlay binding + open
    // and also trigger Flickity init (observer will also catch it; this guarantees init)
    setTimeout(() => {
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', this.close.bind(this));
      // this.open();

      // Try an immediate init (observer will handle edge cases too)
      this.initUpsellFlickity();
    }, 30);
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);


class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


//Coupon Code
class PromoCodeSection extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.target.classList.contains('cart-coupon-main') ? this.querySelector('.promo-code-wrap').classList.toggle('open') : null;
  
    });
  }
}

customElements.define('promo-code-wrap', PromoCodeSection);


class CartCouponCodeButton extends HTMLElement {
  constructor() {
    super();
    let current_form = this;
    this.querySelector('#coupon-form').addEventListener('submit', (event) => {

      event.preventDefault();
      this.submitForm(current_form.querySelector('.promo-input.couponCode').value)
    });
  }
 

   applyCouponCode(discountCode) {
    return new Promise((resolve, reject) => {
      let discountApplyUrl = "https://" + window.location.host + "/discount/" + discountCode;
  
      // Create a hidden iframe to apply discount using the checkout session
      let i = document.createElement('iframe');
      i.style.display = 'none';
      
      // Success: Remove iframe after it loads and log success message
      i.onload = function() {
        console.log("Discount code applied successfully."); // Log success
        i.parentNode.removeChild(i); // Clean up the iframe
        resolve(); // Resolve the promise for success
      };
  
      // Error: Handle iframe loading error
      i.onerror = function() {
        console.error("Failed to apply discount code."); // Log error message
        i.parentNode.removeChild(i); // Clean up the iframe
        reject(new Error("Failed to apply discount code.")); // Reject with error
      };
  
      i.src = discountApplyUrl;
      document.body.appendChild(i); // Append iframe to the body
    });
  }
  
  submitForm(discountCode){
    let current_this = this
    current_this.applyCouponCode(discountCode)
    .then(() => {
        console.log("Discount applied successfully!");
        fetch(`${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`)
        .then((response) => response.json())
        .then((response) => {
            let responseFormated = {
                sections: response
            }
            let cart_drawer = document.querySelector('cart-drawer');
            cart_drawer.renderContents(responseFormated,"discount",discountCode)
            
        })
      })
    .catch(error => {
        console.error("Error applying discount:", error.message);
    });
  }
}

customElements.define('cart-coupon-form', CartCouponCodeButton);

